/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Ebook_Kindle_MobiInputs */

const en_val_ebook_kindle_mobi = /** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBook (Kindle/MOBI)`)
};

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const es_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const fr_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const de_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const ja_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const zh_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const ar_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const id_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const it_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const ru_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const pt_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/** @type {(inputs: Val_Ebook_Kindle_MobiInputs) => LocalizedString} */
const ko_val_ebook_kindle_mobi = en_val_ebook_kindle_mobi;

/**
* | output |
* | --- |
* | "eBook (Kindle/MOBI)" |
*
* @param {Val_Ebook_Kindle_MobiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_ebook_kindle_mobi = /** @type {((inputs?: Val_Ebook_Kindle_MobiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Ebook_Kindle_MobiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_ebook_kindle_mobi(inputs)
	if (locale === "es") return es_val_ebook_kindle_mobi(inputs)
	if (locale === "fr") return fr_val_ebook_kindle_mobi(inputs)
	if (locale === "de") return de_val_ebook_kindle_mobi(inputs)
	if (locale === "ja") return ja_val_ebook_kindle_mobi(inputs)
	if (locale === "zh") return zh_val_ebook_kindle_mobi(inputs)
	if (locale === "ar") return ar_val_ebook_kindle_mobi(inputs)
	if (locale === "id") return id_val_ebook_kindle_mobi(inputs)
	if (locale === "it") return it_val_ebook_kindle_mobi(inputs)
	if (locale === "ru") return ru_val_ebook_kindle_mobi(inputs)
	if (locale === "pt") return pt_val_ebook_kindle_mobi(inputs)
	return ko_val_ebook_kindle_mobi(inputs)
});